<div class="position-relative h-100">
    <div class="row ms-3 me-3 mb-1">
        <div class="w-25">
            <div class="property-width" [ngbTooltip]="'properties.commandsCannotBeExecuted' | translation | async" [disableTooltip]="(isSelectedAssetOffline$ | async) === false" placement="auto">
                <ng-container *appHasPermission="'asset.write'">
                    @if (hasRole) {
                        <button class="btn btn-primary mt-3" (click)="saveProperties()" [disabled]="isSelectedAssetOffline$ | async">{{ 'actions.save' | translation | async }}</button>
                    }
                </ng-container>
            </div>
        </div>
        <div class="col">
            @if (menus$ | async) {
                <app-role-menu-select [selectedRole]="selectedRole" (selectedRoleChange)="selectRoleMenu($event)"></app-role-menu-select>
            }
        </div>
    </div>
    @if (hasRole) {
        <table class="properties-table">
            <tr>
                <td class="properties-tree" [attr.role]="selectedRole">
                    <div *ngFor="let key of menus | ObjectToNumeratedArrayPipe">
                        @if (key !== 'displayName') {
                            <table>
                                <tr>
                                    <td class="w-15px">
                                        <li
                                            [hidden]="!menus[key].submenus.length"
                                            [id]="menus[key].id"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseExample"
                                            [attr.aria-expanded]="getToggleState(menus[key].id)"
                                            aria-controls="collapseExample"
                                            value="false"
                                            (click)="toggle(menus[key].id)"
                                            [class.fa-angle-down]="getToggleState(menus[key].id)"
                                            [class.fa-angle-right]="!getToggleState(menus[key].id)"
                                            class="fas"
                                        ></li>
                                    </td>
                                    <td class="properties-tree-item">
                                        <a [id]="menus[key].id + '_node'" [attr.hierarchyPath]="menus[key].id + '/'" class="tree-node" (click)="onMenuItemClick(menus[key].id)">{{ menus[key]?.displayName?.global }}</a>
                                    </td>
                                </tr>
                            </table>
                            <div class="collapse" id="collapseExample" [ngClass]="{ show: getToggleState(menus[key].id) }">
                                <div class="ps-3">
                                    <app-properties-tree-view
                                        [treeDataSubmenus]="menus[key].submenus"
                                        [treeDataContent]="menus[key].contents"
                                        [hierarchyPath]="menus[key].id + '/'"
                                        (menuItemClicked)="onMenuItemClick($event)"
                                    ></app-properties-tree-view>
                                </div>
                            </div>
                        }
                    </div>
                </td>
                <td class="col-properties">
                    <app-properties
                        [properties]="assetProperties"
                        [propertyValues]="propertyValues"
                        [changeMarkerActive]="true"
                        [isIOLinkDevice]="(isIOLinkDevice$ | async) === 'iolink'"
                        (propertyChanged)="onPropertyChanged()"
                    ></app-properties>
                    <app-commands-properties
                        [commands]="assetCommands"
                        [isCommandExecuting]="isCommandExecuting$ | async"
                        [commandError]="commandErrors$ | async"
                        [isSelectedAssetDisabled]="isSelectedAssetOffline$ | async"
                        (emitExecuteCommand)="executeCommand($event)"
                    ></app-commands-properties>
                    <app-last-known-telemetry-values [telemetries]="assetTelemetries" [lastKnownTelemetryValues]="lastKnownTelemetryValues$ | async"></app-last-known-telemetry-values>
                    @if (!(assetCommands?.length || assetProperties?.length || assetTelemetries?.length)) {
                        <div class="mt-3 text-center">{{ 'properties.noDataFound' | translation | async }}</div>
                    }
                </td>
            </tr>
        </table>
    }

    <ngx-ui-loader [loaderId]="'properties-overview-loader'"></ngx-ui-loader>
</div>
